module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    },
    on: {
      "scroll": function($event) {
        _vm.onScroll($event)
      },
      "click": function($event) {
        _vm.removeSelection()
      }
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "lg6": "",
      "offset-lg3": ""
    }
  }, [_c('v-toolbar', {
    staticStyle: {
      "top": "64px",
      "z-index": "1"
    },
    attrs: {
      "dense": "",
      "flat": "",
      "fixed": "",
      "height": _vm.$vuetify.breakpoint.smAndDown ? (_vm.user.isStore || _vm.user.isRequester || _vm.user.isAdmin ? '170px' : '80px') : '66px'
    }
  }, [_c('v-container', {
    staticClass: "ma-0 px-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": "",
      "lg6": "",
      "offset-lg3": ""
    }
  }, [_c('v-container', {
    staticClass: "mx-0 my-1 pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "px-0 py-0 my-2",
    attrs: {
      "xs4": "",
      "md2": "",
      "d-inline-block": ""
    }
  }, [_c('v-btn', {
    staticClass: "pa-0 mx-0 my-2",
    attrs: {
      "large": "",
      "block": "",
      "outline": "",
      "active-class": "v-btn--active primary"
    },
    on: {
      "click": function($event) {
        _vm.state.listView = !_vm.state.listView
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.state.listView ? 'kartice' : 'tabela') + "\n                    ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-1 py-0 my-2",
    attrs: {
      "xs4": "",
      "md2": "",
      "d-inline-block": ""
    }
  }, [_c('v-btn', {
    staticClass: "pa-0 mx-0 my-2",
    attrs: {
      "large": "",
      "block": "",
      "outline": "",
      "active-class": "v-btn--active primary"
    },
    on: {
      "click": function($event) {
        _vm.state.showActive = !_vm.state.showActive || !_vm.state.showNew;
        _vm.state.showAll = false;
        _vm.state.showLoadMore = true
      }
    },
    model: {
      value: (_vm.state.showActive),
      callback: function($$v) {
        _vm.$set(_vm.state, "showActive", $$v)
      },
      expression: "state.showActive"
    }
  }, [_vm._v("\n                      aktivne\n                    ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0 py-0 my-2",
    attrs: {
      "xs4": "",
      "md2": "",
      "d-inline-block": ""
    }
  }, [_c('v-btn', {
    staticClass: "pa-0 mx-0 my-2",
    attrs: {
      "large": "",
      "block": "",
      "outline": "",
      "active-class": "v-btn--active primary"
    },
    on: {
      "click": function($event) {
        _vm.state.showNew = !_vm.state.showNew || !_vm.state.showActive;
        _vm.state.showAll = false;
        _vm.state.showLoadMore = true
      }
    },
    model: {
      value: (_vm.state.showNew),
      callback: function($$v) {
        _vm.$set(_vm.state, "showNew", $$v)
      },
      expression: "state.showNew"
    }
  }, [_vm._v("\n                      nove\n                    ")])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "px-0 py-0 my-2",
    attrs: {
      "xs12": "",
      "md5": "",
      "offset-md1": "",
      "d-inline-block": ""
    }
  }, [(_vm.user.isStore || _vm.user.isRequester || _vm.user.isAdmin) ? _c('v-btn', {
    staticClass: "primary pa-0 mx-0 my-2",
    attrs: {
      "large": "",
      "block": "",
      "to": "/delivery/new"
    }
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("fa-edit")]), _vm._v("\n                      Nova dostava\n                    ")], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.deliveriesCounter.newDeliveries > 0 && _vm.user.isCourier) ? _c('v-btn', {
    attrs: {
      "round": "",
      "large": "",
      "color": "primary",
      "bottom": "",
      "right": "",
      "absolute": ""
    },
    on: {
      "click": function($event) {
        _vm.$el.scrollIntoView({
          behavior: 'smooth'
        })
      }
    }
  }, [_c('h1', [_vm._v("Nove dostave: " + _vm._s(_vm.deliveriesCounter.newDeliveries))])]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('div', {
    style: (_vm.$vuetify.breakpoint.smAndDown ? (_vm.user.isStore || _vm.user.isRequester || _vm.user.isAdmin ? 'height:170px' : 'height:80px') : 'height:60px')
  }), _vm._v(" "), _vm._l((_vm.deliveries), function(delivery, i) {
    return (!_vm.state.listView && _vm.isVisible(delivery)) ? _c('delivery-view', {
      key: i,
      attrs: {
        "delivery": delivery,
        "expanded": delivery == _vm.selectedDelivery
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.selectDelivery(delivery)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), (_vm.state.listView) ? _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.deliveries,
      "hide-actions": "",
      "loading": _vm.state.loading
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              _vm.selectDelivery(props.item)
            }
          }
        }, [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.from_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.from_address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.to_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.to_address))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.time_accepted)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.time_picked_up)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(props.item.time_delivered)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.courier_id))])])]
      }
    }])
  }, [_c('template', {
    slot: "no-data"
  }, [_vm._v("\n           učitavanje...\n        ")])], 2) : _vm._e(), _vm._v(" "), (_vm.state.showLoadMore) ? _c('v-btn', {
    staticClass: "pa-0 mx-0 my-2",
    attrs: {
      "large": "",
      "block": "",
      "outline": "",
      "loading": _vm.state.loading
    },
    on: {
      "click": function($event) {
        _vm.loadMore()
      }
    }
  }, [_vm._v("\n        učitaj i završene dostave\n      ")]) : _vm._e()], 2), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "400px"
    },
    model: {
      value: (_vm.assignDialog),
      callback: function($$v) {
        _vm.assignDialog = $$v
      },
      expression: "assignDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary"
  }, [_c('h4', [_vm._v("Dodeli kuriru")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.couriers), function(courier, j) {
    return _c('v-list-tile', {
      key: j,
      class: {
        accent: courier.selected
      },
      on: {
        "click": function($event) {
          _vm.selectCourier(courier)
        }
      }
    }, [_c('v-list-tile-content', [_c('span', {
      style: ({
        color: courier.online == 0 ? 'gray' : 'inherit'
      })
    }, [_c('span', [_vm._v(_vm._s(courier.name))]), _vm._v(" "), _c('span', [_c('v-btn', {
      attrs: {
        "fab": "",
        "dark": "",
        "small": "",
        "color": courier.online ? 'green' : 'grey'
      }
    }, [_vm._v(_vm._s(courier.active_deliveries_count))])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(courier.latest_address))]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.formatTimeCourier(courier.latest_event)))])])])], 1)
  })), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "block": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.assignDelivery($event)
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}